/**
 * Consume ?handoff= from native app open → Firebase custom token sign-in.
 */
import { signInWithCustomToken } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { getFirebaseAuth, getFirebaseFunctions } from '../config/firebase';
import { replacePath } from '../routing';

function stripHandoffFromUrl(): string | null {
  const url = new URL(window.location.href);
  const handoffId = url.searchParams.get('handoff');
  if (!handoffId) return null;
  url.searchParams.delete('handoff');
  replacePath(`${url.pathname}${url.search}${url.hash}`);
  return handoffId;
}

/**
 * If the URL has a one-time handoff id, exchange it and sign in.
 * Safe to call once at boot; no-ops when absent.
 */
export async function consumePortalHandoffIfPresent(): Promise<{
  consumed: boolean;
  error?: string;
}> {
  const handoffId = stripHandoffFromUrl();
  if (!handoffId) return { consumed: false };

  try {
    const fn = httpsCallable(getFirebaseFunctions(), 'consumeBillingPortalHandoff');
    const res = await fn({ handoffId });
    const customToken = (res.data as { customToken?: string })?.customToken;
    if (!customToken) {
      return { consumed: false, error: 'Handoff inválido' };
    }
    await signInWithCustomToken(getFirebaseAuth(), customToken);
    return { consumed: true };
  } catch (e) {
    const message =
      e && typeof e === 'object' && 'message' in e
        ? String((e as { message: string }).message)
        : 'Falha ao entrar pela sessão do app';
    return { consumed: false, error: message };
  }
}
